<a
  *ngFor="let l of links"
  tabindex="0"
  (keydown.enter)="goToFragment(l.target)"
  (click)="goToFragment(l.target)"
  >{{ l.text | translate }}</a
>
